<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">{{ 'sending_login_info' | localise }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onClose()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="form-block">
                <form class="pt-3" [formGroup]="loginForm">
                    <div class="form-group" *ngIf="profile">
                        <label class="font-weight-bold">E-Mail:</label>

                        <input type="text" name="email" value="{{ profile.email }}" disabled class="form-control form-control-lg"/>
                    </div>

                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'auth_password' | localise }}:</label>

                        <input type="text" name="password" class="form-control form-control-lg" formControlName="password">
                    </div>

                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'upload_files' | localise }}</label>

                        <input
                                multiple="multiple"
                                class="file"
                                #inputFile
                                type="file"
                                (change)="handleFileInput($event)"
                        />
                    </div>

                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'upload_text' | localise }}</label>

                        <textarea id="editor1">
                            <p>Здравейте,<br />
<br />
Прилагам необходимата информация за достъп до системата и респективно, хранителният план.<br />
<br />
Можете да свалите апликацията от <a href="https://apps.apple.com/app/agaia-life/id1589104436" target="_blank"><strong>AppStore</strong></a> или <a href="https://play.google.com/store/apps/details?id=life.agaia.app" target="_blank"><strong>Google play</strong></a> под името <strong>Agaia life</strong>.<br />
<br />
Ако ползвате друга система, можете да влезете посредством този линк:&nbsp;<a href="https://dashboard.agaia.life/meals" target="_blank">https://dashboard.agaia.life/meals</a><br />
<br />
<strong>Данни за достъп и за двата варианта са:</strong><br />
<strong>Вашият имейл</strong> - {email}<br />
<strong>Парола</strong> - {password}<br />
<br />
Не трябва да има главни букви и разстояния в изписването на имейла и паролата
<br />
Хранителният план е зареден напред в календара за два месеца. Листа за пазаруване се генерира от дата до дата, а не за дълъг период от време. Избира се от календарното меню. Хубаво е да е съобразен листа за пазаруване с дните от ротационният цикъл за да са свежи продуктите.
<br/>
Започваме с това меню и след около осем седмици е хубаво да направим анализ да видим как се движите и да преценим какво и в каква посока да променяме. Разбира се, това е ако решите да продължите работа с нас. Моля, обаждайте се с поне месец предварение за часове предвид заетият график.
<br />
Също, приложени са основни принципи, за които искам да се внимава и разбира се са с образователна цел.:<br />
<br />
Това е като цяло. Оставам на разположение.
<br />
<br />
<br />
Поздрави,<br />
Team Agaia<br />
<a href="tel:0879570628" target="_blank">0879570628</a></p>
                        </textarea>
                    </div>
                </form>

                <div class="clear"></div>

                <button type="button" class="btn btn-block btn-success filter-btn"
                        (click)="onCreate()">{{ 'site_send' | localise }}
                </button>
            </div>
        </div>
    </ng-container>
</div>
